import {Component, computed} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Card} from 'primeng/card';
import {ProjectBaseStepComponent} from '../../../project-base-step/project-base-step.component';
import {ProjectChapterType, ProjectStepType, TenderPhaseType} from '@frontend/shared-api';
import {ProviderResultsTableComponent} from '../../../../../../shared/components/table/provider-results-table/provider-results-table.component';
import {PreviousStepIncompleteNoticeComponent} from '../../../../../../shared/components/previous-step-incomplete-notice/previous-step-incomplete-notice.component';

@Component({
  selector: 'app-step-8-5-provider-results',
  imports: [
    TranslocoPipe,
    Card,
    ProviderResultsTableComponent,
    PreviousStepIncompleteNoticeComponent,
  ],
  templateUrl: './step-8-5-provider-results.component.html',
})
export class Step85ProviderResultsComponent extends ProjectBaseStepComponent {
  protected readonly TenderPhaseType = TenderPhaseType;

  protected readonly isStepPrerequisiteCompleted = computed(() => {
    return this.stepState.areStepsCompleted([
      {chapterId: ProjectChapterType.RFQ, stepId: ProjectStepType.RFQ_PROVIDER_INVITATION},
    ]);
  });
}
